module.exports = require("react-dates/lib/css/_datepicker.css");